/**
 * @generated SignedSource<<6113d86ec58447dd4d6476057752f5d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SubIssuesListViewViewer$data = {
  readonly isEmployee: boolean;
  readonly " $fragmentType": "SubIssuesListViewViewer";
};
export type SubIssuesListViewViewer$key = {
  readonly " $data"?: SubIssuesListViewViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssuesListViewViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubIssuesListViewViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmployee",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1aa936852ac406154dfb9323174dd7e7";

export default node;
